const config = {
    apiUrl: "https://infi-node-stg.medibuddy.in/",
    downloadFileUrl: "https://sme-ui.s3.ap-south-1.amazonaws.com/SME+Template.xlsx",
    razorpayKey: "rzp_live_324Am2gp3yOsFU",
    clevertapId: "649-47W-Z55Z"
}

export default config